(function ($) {

    irisValidation($('#sdks-apis-form'), {
        focusFirstInput: false,
        validators: {
            firstname: 'firstName',
            lasstname: 'lastName',
            email: 'email',
            company: 'companyName',
        },
        filters: {
            utm_source: 'utm_param',
            utm_campaign: 'utm_param',
            utm_medium: 'utm_param',
            conversion_url: 'page_url',
            utm_gclid: 'utm_param',
            utm_term: 'utm_param',
            utm_content: 'utm_param',
            pagename: 'page_url',
        },
        validateByTimeout: ['email'],
        errorMessages: {
            required: 'This field is required',
            emailFormat: 'Not a valid email',
            connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
        },
        success: function (data) {
            var formSelector = this.formSelector;
            $(formSelector + ' .form-group').css({opacity: 0});
            this.showResult("<p>We've received your submission and we're currently processing your request. Our team is working hard to review your information and get back to you as soon as possible. Rest assured, we'll be in touch shortly with more details on how we can assist you further.</p><p>Once again, thank you for your interest and we look forward to speaking with you soon.</p>", true);
            setTimeout(function () {
                $(formSelector + ' .submission-result').css({opacity: 1});
            },500)
        }
    });

})(jQuery);
